export const CROSSCHAIN_STEPS_NUMBER = 2;
export const BLUESCHAIN_ID = 9999;
